import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import InstallationAddress from '../InstallationAddress/InstallationAddress.js';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import { tLoc } from '../../i18n/translate.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import '../Rssi/RssiComponent.js';
import '../FirmwareUpgrade/FirmwareUpgrade.js';
import '../FirmwareUpgrade/FirmwareUpgradeConfirm.js';
import '../SessionController/SessionController.js';
import '../MagnetTest/TestMagnetComponent.js';
import '../AccessTokenPanel/AccessTokenPanel.js';
import '../LogoutModal/LogoutModal.module.scss.js';
import '../FirmwareUpgrade/logic/firmware.gql.js';
import 'lodash';
import '../billingAddress/BillingAddressForm.js';
import '../GuardInfo/LocationMap.js';
import '../GuardInfo/GuardAccessDirection.js';
import '../GuardInfo/GuardWaterDirection.js';
import '../CodeWordInput/CodeWordInput.js';
import '../CreateUser/UserForm/UserForm.js';
import '../CreateUser/AlarmContact/AlarmContact.js';
import '../CreateUser/AccessLevel/AccessLevel.js';
import '../EmergencyContactList/EmergencyContactListComponent.js';
import '../EmergencyContactElement/EmergencyContactElementComponent.js';
import '../Alias/Alias.js';
import '../InstallationAddress/UpdatableInstallationAddress.js';
import '../ArmedStay/ArmedStayDeviceList.js';
import '../PhoneNumberForm/PhoneNumberForm.js';
import '../PinCode/PinCode.js';
import '../PinCode/SuccessPinCode.js';
import '../Alert/Alert.js';
import '../IntrusionVolume/IntrusionVolume.js';
import '../PetSettings/PetType.js';
import '../PetSettings/PetSettings.js';
import '../PetSettings/PetSettings.gql.js';
import '../PetSettings/PetWeight.js';
import '../TestTypeScript/PetWeight.module.scss.js';
import '../DevicesAdjustedForPets/DevicesAdjustedForPets.js';
import '../ArmDisarmPanel/ArmDisarmPanel.js';
import '../VoiceTest/VoiceTestComponent.js';
import '../MicroFrontendErrorBoundary/MicroFrontendErrorBoundary.js';
import '../ShippingAddressSelection/AddressSelectionItem.module.scss.js';
import styles from './RequestInstallationAddressChange.module.scss.js';
import { getInstallationAddressQuery } from './InstallationAddressSlice.js';

function RequestInstallationAddressChange(_ref) {
  var client = _ref.client,
    giid = _ref.giid,
    dealerSettings = _ref.dealerSettings;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    installationAddress = _useState2[0],
    setInstallationAddress = _useState2[1];
  var refreshInstallationAddress = function refreshInstallationAddress() {
    var getInstallationAddress = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var fetchedInstallationAddress;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getInstallationAddressQuery(client, giid);
              case 2:
                fetchedInstallationAddress = _context.sent;
                setInstallationAddress(fetchedInstallationAddress);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function getInstallationAddress() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (giid) {
      getInstallationAddress();
    }
  };
  useEffect(function () {
    if (giid) {
      refreshInstallationAddress();
    }
  }, [giid]);
  return installationAddress === null ? /*#__PURE__*/React.createElement(LoadingSpinner, {
    centered: true,
    absolute: true,
    isLoading: true,
    size: "medium"
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: classNames(styles.divider, 'secondary')
  }, tLoc('MPLIB_SYSTEM_SETTINGS_CONTACT_CUSTOMER_SERVICE_TO_UPDATE_ADDRESS_HEADER')), installationAddress && /*#__PURE__*/React.createElement(InstallationAddress, {
    installationAddress: installationAddress
  }), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: classNames(styles.divider, 'secondary')
  }, tLoc('MPLIB_SYSTEM_SETTINGS_CONTACT_CUSTOMER_SERVICE_TO_UPDATE_ADDRESS_INFO')), /*#__PURE__*/React.createElement("p", null, tLoc('MPLIB_SYSTEM_SETTINGS_TO_CONTACT_US_CALL')), /*#__PURE__*/React.createElement("p", {
    className: classNames(styles.emphasized)
  }, dealerSettings === null || dealerSettings === void 0 ? void 0 : dealerSettings.phone), /*#__PURE__*/React.createElement("p", null, tLoc('MPLIB_SYSTEM_SETTINGS_TO_CONTACT_US_CALL_ABROAD')), /*#__PURE__*/React.createElement("p", {
    className: styles.emphasized
  }, dealerSettings === null || dealerSettings === void 0 ? void 0 : dealerSettings.phoneInternational))));
}
RequestInstallationAddressChange.propTypes = {
  giid: PropTypes.string.isRequired,
  dealerSettings: PropTypes.shape({
    phone: PropTypes.string,
    phoneInternational: PropTypes.string
  }).isRequired,
  client: PropTypes.shape({
    query: PropTypes.func.isRequired,
    mutate: PropTypes.func.isRequired
  }).isRequired
};

export { RequestInstallationAddressChange as default };
